import styled from 'styled-components';

// Material-UI
import IconButton from '@material-ui/core/IconButton';

// *************************************
// STYLED COMPONENTS                               
// *************************************

// IconButton
export const StyledButtonIcon = styled(IconButton)`
  &.MuiIconButton-root {
    padding: 8px;
    color: ${(props) => props.theme.colors.greyDark}; 
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};
    }
  }

  &.MuiIconButton-root.Mui-disabled {
    color: ${(props) => props.theme.colors.greyMedium};
  }

  &.MuiIconButton-colorPrimary {
    color: ${(props) => props.theme.colors.greyDark}; 
    &:hover {
      color: ${(props) => props.theme.colors.blueMedium}; 
      background-color: ${(props) => props.theme.colors.blueMediumAlpha};
    }
  }

  &.MuiIconButton-colorSecondary {
    color: ${(props) => props.theme.colors.greyDark}; 
    &:hover {
      color: ${(props) => props.theme.colors.red}; 
      background-color: ${(props) => props.theme.colors.greyHover};
    }
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;